import Swal from 'sweetalert2';

const ErrorView = (message) => {
  Swal.fire({
    title: 'システム内部エラー',
    text: message,
    showCancelButton: true,
    icon: 'error',
    confirmButtonColor: '#33ab9f',
  });
};
export default ErrorView;